import type { MemberAttendanceQueryParams } from "@membentry/shared-types";

/** React Query key factory for member attendance. */
export const MY_ATTENDANCE_QUERY_KEY = "my-attendance";

export const myAttendanceQueryKey = (params: MemberAttendanceQueryParams) =>
  [MY_ATTENDANCE_QUERY_KEY, params.clubId, params.startDate, params.endDate, params.page, params.pageSize] as const;
